const ADDRESS_LIST_PREFIX = "al";

export const ADDRESS_LIST_TEST_IDS = {
    HALF_CARD_LOADER: `${ADDRESS_LIST_PREFIX}_hcl`,
    HALF_CARD_ERROR: `${ADDRESS_LIST_PREFIX}_hce`,
    HALF_CARD_ERROR_CTA: `${ADDRESS_LIST_PREFIX}_hce_cta`,
    HALF_CARD_ERROR_CTA_ADD_ADDRESS: `${ADDRESS_LIST_PREFIX}_hce_cta_add_address`,
};
